var exports = {
  "K": "xe533113f--b6b134--highway-item",
};

module.exports = exports;
